import React from "react";
import { useDataTypesList } from "./DataTypesList.hooks.ts";
import { DotLegalButton, DotLegalOverflowMenu, DotLegalPageHeader, DotLegalTableWithControls, ITableHeader } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../../localization/useTranslation.ts";
import AddEditDataTypeDialog from "./AddEditDataTypeDialog.tsx";
import { DataType } from "./DataTypesList.types.ts";
import { Box, TableCell, TableRow } from "@mui/material";
import DotLegalDeleteDialogWrapper from "../../../common/components/dotLegalDeleteDialog/DotLegalDeleteDialogWrapper.tsx";
import TablePagePaper from "@common/components/tablePagePaper/TablePagePaper";

export interface IDataTypesListProps {}

function DataTypesList(props: IDataTypesListProps) {
    const {
        isLoading,
        dataTypes,
        breadCrumbs,
        canManageMasterData,
        onCreateClick,
        createDialogOpen,
        onUpdateClick,
        onDialogClose,
        onSaved,
        dataTypeToUpdate,
        getMenuItems,
        dataTypeForDeletion,
        setDataTypeForDeletion,
        onDelete,
    } = useDataTypesList();
    const { translateString } = useTranslation();

    const headers = Array<ITableHeader<DataType>>();
    headers.push({ property: "name", text: translateString("name") });
    return (
        <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
            <DotLegalPageHeader
                breadCrumbs={breadCrumbs}
                rightComponent={
                    canManageMasterData ? (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <DotLegalButton buttonType="primary" size="medium" onClick={onCreateClick}>
                                {translateString("createDataType")}
                            </DotLegalButton>
                        </Box>
                    ) : undefined
                }
            />
            <TablePagePaper>
                <DotLegalTableWithControls
                    internalScroll
                    headers={headers}
                    isLoading={isLoading}
                    data={dataTypes}
                    emptyText={translateString("noDataTypes")}
                    defaultOrderBy={"name"}
                    hideRowsPerPage
                    getUserSpecificPageLength={() => 100}
                    labelRowsPerPage={translateString("showEntites")}
                    labelSearch={translateString("search")}
                    noOptionsLabel={translateString("noOptions")}
                    paginationLabelOf={translateString("labelOf")}
                    hasOverflowMenu
                    clickableRows={canManageMasterData}
                    renderRow={(row) => (
                        <TableRow key={row.id} onClick={canManageMasterData ? () => onUpdateClick(row.id) : undefined}>
                            <TableCell>{row.name}</TableCell>
                            <TableCell align={"right"}>
                                <DotLegalOverflowMenu items={getMenuItems(row)} />
                            </TableCell>
                        </TableRow>
                    )}
                />
            </TablePagePaper>
            {dataTypeForDeletion && (
                <DotLegalDeleteDialogWrapper
                    open
                    onDialogClose={() => setDataTypeForDeletion(undefined)}
                    onOkClick={onDelete}
                    itemForDeletion={dataTypeForDeletion.name}
                />
            )}
            {(createDialogOpen || dataTypeToUpdate !== undefined) && (
                <AddEditDataTypeDialog isAdd={createDialogOpen} toUpdate={dataTypeToUpdate} onSaved={onSaved} onDialogClose={onDialogClose} />
            )}
        </Box>
    );
}

export default DataTypesList;
